<section class="blog-home" *ngIf="articles.length" aria-labelledby="blog-home-title">
  <div class="container">
    <header class="blog-home-head">
      <div>
        <h3 id="blog-home-title">Stories &amp; Travel Guides</h3>
        <p>Tips, routes and tales from our crew in East Indonesia</p>
      </div>
      <a routerLink="/blog" class="view-all">View all articles <i class="fa-solid fa-arrow-right"></i></a>
    </header>

    <div class="blog-grid" [class.one]="articles.length === 1" [class.two]="articles.length === 2">
      <article class="post" *ngFor="let article of articles; let first = first; trackBy: trackById" [class.lead]="first">
        <a class="post-link" [routerLink]="['/blog', article.slug]">
          <div class="post-media">
            <img [src]="articleService.coverUrl(article)" [alt]="article.title" loading="lazy">
          </div>
          <div class="post-body">
            <h4 class="post-title">{{ article.title }}</h4>
            <p class="post-excerpt">{{ article.excerpt }}</p>
            <p class="post-meta">
              <span *ngIf="article.category">{{ article.category }}</span>
              <span>{{ articleService.formatDate(article.published_at) }}</span>
              <span>{{ article.reading_minutes }} min read</span>
            </p>
          </div>
        </a>
      </article>
    </div>
  </div>
</section>
